import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import dayjs from 'dayjs'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

type TotalTransactionFeesChartProps = {
  data: number[]
  activeIndex?: number
  className?: string
}

export const TotalTransactionFeesChart = ({ data, activeIndex, className }: TotalTransactionFeesChartProps) => {
  const { __, __n } = useTranslator()

  const labels = Array.from({ length: data.length }, (_, i) => `${i + 1}`)

  return (
    <div className={className}>
      <Bar
        data={{
          labels,
          datasets: [
            {
              label: __('Total Transaction Fees'),
              data,
              backgroundColor: data.map((_, i) => (i === activeIndex ? '#3551F2' : 'rgba(53, 81, 242, 0.18)')),
              borderRadius: 8,
              borderSkipped: false,
              barThickness: 36,
              hoverBackgroundColor: data.map((_, i) => (i === activeIndex ? '#3551F2' : 'rgba(53, 81, 242, 0.28)'))
            }
          ]
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: '#1E293B',
              titleColor: '#FFFFFF',
              bodyColor: '#FFFFFF',
              displayColors: false,
              padding: 8,
              cornerRadius: 8,
              callbacks: {
                title: items => {
                  const idx = items?.[0]?.dataIndex ?? 0
                  const monthIndex = Number(labels[idx]) - 1
                  const monthName = dayjs().month(monthIndex).format('MMMM')

                  return monthName
                },
                label: context => {
                  const value = Number((context.parsed as any)?.y ?? 0)

                  return __n(value) + ' đ'
                }
              }
            }
          },
          interaction: { mode: 'index', intersect: false },
          scales: {
            x: {
              grid: { display: false },
              border: { display: false },
              ticks: {
                color: '#C2C4CC',
                font: { size: 12 }
              }
            },
            y: {
              beginAtZero: true,
              grid: { color: 'rgba(0,0,0,0.06)', display: false },
              border: { display: false },
              ticks: { display: false }
            }
          },
          layout: { padding: { top: 8 } }
        }}
      />
    </div>
  )
}

export default TotalTransactionFeesChart
